// extracted by mini-css-extract-plugin
export var card = "_5i-0";
export var content = "_5i-1";
export var contentLoading = "_5i-2";